import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../common/cards/Card';
import DefaultAvatar from '../../../assets/icons/svgIcons/avatar.svg';
import Avatar from '@material-ui/core/Avatar';
import styles from './CardStyle.module.scss';
import { generatePath, useHistory } from 'react-router-dom';
import { routes } from '../../../assets/routes';

const LikeInfoCard = (props) => {
  const history = useHistory();

  return (
    <Card
      {...props}
      onClick={() => {
        history.push(generatePath(routes.PROFILE, { id: props.data.id }));
      }}
    >
      <div className={styles.wrapper}>
        <div className={styles.body}>
          <div className={styles.info}>
            <div className={styles.pics}>
              <Avatar
                alt={props.data.first_name}
                src={props.data.avatar?.thumbnail || DefaultAvatar}
                className={styles.small}
              />
              <span>{`${props.data.first_name} ${props.data.last_name}`}</span>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

LikeInfoCard.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    img: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    avatar: PropTypes.shape({
      thumbnail: PropTypes.string
    })
  })
};

export default LikeInfoCard;
